import * as React from 'react'
import type {SVGProps} from 'react'
const SvgIconLoyalty3StepEarn = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={74} height={74} viewBox="0 0 74 74" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#142745"
                strokeWidth={2.658}
                d="M40.27 52.865C40.27 63.432 31.705 72 21.136 72 10.568 72 2 63.432 2 52.865c0-10.569 8.568-19.136 19.135-19.136 10.569 0 19.136 8.567 19.136 19.136Z"
            />
            <path
                fill="#142745"
                fillRule="nonzero"
                d="M22.525 65.375V62.8c3.225-.425 5.525-2.5 5.525-5.725 0-7.075-10.85-4.55-10.85-8.775 0-1.85 1.45-2.525 3.275-2.525 2.375 0 3.525 1.2 3.525 2.675h2.975c0-2.525-1.65-4.475-4.45-5.1v-2.7h-3.15v2.55c-2.9.375-5.125 2.25-5.125 5.225 0 6.9 10.85 4.375 10.85 8.95 0 1.65-1.425 2.85-3.85 2.85-2.675 0-4.35-1.475-4.35-3.925h-2.95c0 3.6 2.05 5.825 5.425 6.425v2.65z"
            />
            <path
                stroke="#142745"
                strokeWidth={2.658}
                d="M72 21.135c0 10.568-8.567 19.135-19.135 19.135S33.73 31.703 33.73 21.135 42.297 2 52.865 2 72 10.567 72 21.135Z"
            />
            <path
                fill="#E9F2FF"
                d="m53.194 12.907 2.337 5.666c.146.354.48.597.863.627l6.11.47c.906.071 1.274 1.203.582 1.792l-4.665 3.973a1.02 1.02 0 0 0-.331 1.016l1.44 5.955c.214.885-.75 1.585-1.524 1.108l-5.22-3.21a1.01 1.01 0 0 0-1.068 0l-5.218 3.21c-.776.477-1.739-.223-1.526-1.108l1.44-5.955a1.02 1.02 0 0 0-.33-1.016l-4.665-3.973c-.693-.589-.324-1.72.582-1.792l6.11-.47a1.02 1.02 0 0 0 .863-.627l2.336-5.666c.347-.84 1.538-.84 1.884 0"
            />
            <path
                fill="#142745"
                d="m54.682 10.458 2.336 5.664c.146.356.48.598.864.628l6.11.47c.906.071 1.274 1.204.582 1.793l-4.667 3.971c-.292.25-.42.642-.33 1.017l1.44 5.955c.214.884-.749 1.584-1.523 1.108l-5.22-3.21a1.02 1.02 0 0 0-1.068 0l-5.219 3.21c-.775.476-1.738-.224-1.525-1.108l1.44-5.955a1.02 1.02 0 0 0-.33-1.017l-4.665-3.971c-.693-.59-.325-1.722.582-1.792l6.11-.471c.382-.03.717-.272.863-.628l2.336-5.664c.347-.841 1.537-.841 1.884 0"
            />
            <g stroke="#142745" strokeLinecap="round" strokeWidth={2.658}>
                <path d="M5.718 31.217 30.122 6.814" />
                <path strokeLinejoin="round" d="M24.628 6.026h6.29v6.288" />
            </g>
            <g stroke="#142745" strokeLinecap="round" strokeWidth={2.658}>
                <path d="M67.936 43.046 43.533 67.45" />
                <path strokeLinejoin="round" d="M49.025 68.238h-6.288v-6.289" />
            </g>
        </g>
    </svg>
)
export default SvgIconLoyalty3StepEarn
